<wbo-search-page [editParams]="extendedSearchParams?.searchParams">
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="identifier">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="supplier">
                <wbo-supplier-multi-select-search-control></wbo-supplier-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    <wbo-search-form-extended-fields>
        <wbo-search-form-field *extendedField="'customObjectId'">
            <wbo-custom-object-multi-select-search-control [inventoryContext]="true"></wbo-custom-object-multi-select-search-control>
        </wbo-search-form-field>
        <wbo-search-form-field *extendedField="'status'">
            <wbo-entity-availability-single-select-search-control></wbo-entity-availability-single-select-search-control>
        </wbo-search-form-field>
    </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-column field="size"></wbo-column>
        <wbo-column field="preferredsupplier"></wbo-column>
        <wbo-column field="inventorygroup"></wbo-column>
        <wbo-actions-search-column>
            <wbo-discontinue-search-action></wbo-discontinue-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
